import React, { useState, useEffect, useRef } from "react";
import leftTree from "../../assets/images/left-tree.png";
import righttree from "../../assets/images/right-tree.png";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faPlay, faExpand, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchVideos } from "../../features/videoSlice";
import "../Homepage/home.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function ytVideoId(url) {
  const m = url.match(/(?:youtu\.be\/|shorts\/|live\/|v=)([\w-]+)/);
  return m ? m[1] : "";
}

function ytThumb(url) {
  const id = ytVideoId(url);
  return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : "";
}

const VideoCard = ({ item, onOpenPopup }) => {
  const [active, setActive] = useState(false);
  const thumbRef = useRef(null);

  useEffect(() => {
    const el = thumbRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) setActive(false);
      },
      { threshold: 0 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="amv-card">
      <div className="amv-thumb" ref={thumbRef}>
        <img
          src={ytThumb(item.you_tube_video_link)}
          alt={item.product?.product_name || item.title}
          className="amv-thumb-img"
          style={{ display: active ? "none" : "block" }}
        />
        {!active && (
          <div className="amv-thumb-overlay" onClick={() => setActive(true)}>
            <div className="amv-play-circle">
              <FontAwesomeIcon icon={faPlay} />
            </div>
          </div>
        )}
        {active && (
          <div className="amv-inline-player">
            <ReactPlayer
              url={item.you_tube_video_link}
              playing
              controls
              width="100%"
              height="100%"
              config={{ youtube: { playerVars: { modestbranding: 1, rel: 0 } } }}
            />
          </div>
        )}
      </div>

      <div className="amv-card-body">
        <p className="amv-product-name">{item.product?.product_name || item.title}</p>
        <p className="amv-product-price">RM {item.product?.actual_price}</p>
        <div className="amv-btn-row">
          <Link to={`/product-details/${item.product?.slug}`} className="amv-shop-btn">
            Shop Now
          </Link>
          <button
            className="amv-popup-btn"
            onClick={() => onOpenPopup(item.you_tube_video_link, item.product?.slug)}
            title="Watch in fullscreen"
          >
            <FontAwesomeIcon icon={faExpand} />
            Watch
          </button>
        </div>
      </div>
    </div>
  );
};

const Videos = () => {
  const [modalVideo, setModalVideo] = useState(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const dispatch = useDispatch();
  const { videos, status } = useSelector((state) => state.videoslice);

  useEffect(() => {
    if (status === "idle") dispatch(fetchVideos());
  }, [dispatch, status]);

  if (!videos || videos.length === 0) return null;

  const validVideos = videos.filter((v) => ytVideoId(v.you_tube_video_link));
  if (validVideos.length === 0) return null;

  const openPopup  = (link, slug) => setModalVideo({ link, slug });
  const closePopup = ()           => setModalVideo(null);

  return (
    <div className="amv-section mt-4">
      <div className="container">
        <div className="amv-heading-row">
          <div className="amv-heading-inner">
            <img src={leftTree} alt="" className="amv-heading-img" />
            <h2 className="amv-heading-text">Videos</h2>
            <img src={righttree} alt="" className="amv-heading-img" />
          </div>
        </div>

        {validVideos.length >= 3 ? (
          <div className="amv-swiper-wrap">
            <button ref={prevRef} className="amv-nav-btn amv-nav-prev" aria-label="Previous slide">
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <button ref={nextRef} className="amv-nav-btn amv-nav-next" aria-label="Next slide">
              <FontAwesomeIcon icon={faChevronRight} />
            </button>

            <Swiper
              className="amv-swiper"
              modules={[Navigation, Pagination, A11y]}
              navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
              onSwiper={(swiper) => {
                swiper.params.navigation.prevEl = prevRef.current;
                swiper.params.navigation.nextEl = nextRef.current;
                swiper.navigation.init();
                swiper.navigation.update();
              }}
              pagination={{ clickable: true }}
              spaceBetween={20}
              slidesPerView={1}
              breakpoints={{
                480: { slidesPerView: 1, spaceBetween: 16 },
                640: { slidesPerView: 2, spaceBetween: 18 },
                992: { slidesPerView: 3, spaceBetween: 20 },
                1200: { slidesPerView: 3, spaceBetween: 24 },
              }}
              grabCursor
              a11y={{ prevSlideMessage: "Previous video", nextSlideMessage: "Next video" }}
            >
              {validVideos.map((item) => (
                <SwiperSlide key={item.id}>
                  <VideoCard item={item} onOpenPopup={openPopup} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        ) : (
          <div className="amv-flex-grid">
            {validVideos.map((item) => (
              <div className="amv-flex-item" key={item.id}>
                <VideoCard item={item} onOpenPopup={openPopup} />
              </div>
            ))}
          </div>
        )}
      </div>

      {modalVideo && (
        <div className="amv-modal-overlay" onClick={closePopup}>
          <div className="amv-modal-box" onClick={(e) => e.stopPropagation()}>
            <button className="amv-modal-close" onClick={closePopup} aria-label="Close video">
              <FontAwesomeIcon icon={faXmark} />
            </button>
            <ReactPlayer
              url={modalVideo.link}
              width="100%"
              height="100%"
              playing
              controls
              config={{ youtube: { playerVars: { rel: 0, modestbranding: 1 } } }}
            />
            {modalVideo.slug && (
              <Link
                to={`/product-details/${modalVideo.slug}`}
                className="amv-modal-shop-btn"
                onClick={closePopup}
              >
                Shop Now
              </Link>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Videos;
